import React from 'react'
import "./FloatingPeople.css"
import PersonOneLeft from '../../assets/images/Frame-1.png'
import PersonTwoLeft from '../../assets/images/Frame-2.png'
import PersonThreeLeft from '../../assets/images/Frame-3.png'
import PersonFourLeft from '../../assets/images/Frame-4.png'
import PersonFiveLeft from '../../assets/images/Frame-5.png'
import PersonSixLeft from '../../assets/images/Frame-6.png'
import PersonSevenLeft from '../../assets/images/Frame-7.png'
import PersonEightLeft from '../../assets/images/Frame-8.png'
import PersonNineLeft from '../../assets/images/Frame-9.png'
import PersonTenLeft from '../../assets/images/Frame-10.png'
import calendarIcon from '../../assets/images/calendar-icon.svg'
import pencilIcon from '../../assets/images/pencil-icon.svg'
import heartIcon from '../../assets/images/heart-icon.svg'
import userIcon from '../../assets/images/user-icon.svg'


const FloatingPeople = () => {
  return (
    <div className='uk-section height-100 uk-overflow-hidden' >
        <div className='uk-container uk-height-1-1'>

            <div className='uk-height-1-1 uk-flex uk-flex-column z-index-top top-z' uk-scrollspy="target: [uk-scrollspy-class]; cls: uk-animation-slide-bottom-small; delay:0; offset-top: 100; repeat: true;">

                <div className="trip-heading-display uk-text-center trip-ultra  uk-margin-auto-bottom" uk-scrollspy-class="">
                All that good stuff added up. This year, the community reached over a billion contributions…


                </div>

                <div className='trip-heading-display uk-text-center trip-ultra uk-width-3-4@l uk-margin-auto' uk-scrollspy-class="uk-animation-slide-top-medium"> 
                …and said hello to nearly 35.7MM new travel buddies.

                </div>
            </div>

            {/* <div uk-scrollspy="target: [uk-scrollspy-class]; cls: uk-animation-slide-bottom-medium; delay: 120;"> */}
            <div>

            

            <div className="uk-panel uk-width-1-1" uk-scrollspy="target: [uk-scrollspy-class]; cls: uk-animation-slide-bottom-medium; delay: 120;">            
                                    
                <div className="uk-position-absolute uk-scrollspy-inview person-one-left uk-animation-slide-bottom-medium" uk-scrollspy-class="">
                    <img src={PersonOneLeft} alt="person one left" className='uk-border-circle people-border'/>
                </div>
          
                <div className="uk-position-absolute uk-scrollspy-inview person-two-left uk-animation-slide-bottom-medium uk-visible@s">
                    <img src={PersonTwoLeft} alt="person one left" className='uk-border-circle people-border'/>
                    <img src={calendarIcon} alt="calendar icon" className="" style={{marginTop: "-45px", marginLeft:"-20px", border:"solid 3px #000", borderRadius:"100px", backgroundColor:"#fff", width:"50px" }} />
                </div>
          
                <div className="uk-position-absolute uk-scrollspy-inview person-three-left uk-animation-slide-top-medium">
                <img src={PersonThreeLeft} alt="person one left" className='uk-border-circle people-border'/>
                <img src={heartIcon} alt="heart icon" className="" style={{marginLeft:"-45px", border:"solid 3px #000", borderRadius:"100px", backgroundColor:"#fff", width:"50px", position:"absolute" }} />
                </div>
          
                <div className="uk-position-absolute uk-scrollspy-inview person-four-left uk-animation-slide-bottom-medium" >
                    <img src={PersonFourLeft} alt="person one left" className='uk-border-circle people-border'/>
                </div>

                <div className="uk-position-absolute uk-scrollspy-inview person-five-left uk-animation-slide-top-medium">
                     <img src={PersonFiveLeft} alt="person one left" className='uk-border-circle people-border'/>
                </div>

                <div className="uk-position-absolute uk-scrollspy-inview person-six-left uk-animation-slide-bottom-medium">
                    <img src={PersonSixLeft} alt="person one left" className='uk-border-circle people-border'/>
                    <img src={userIcon} className="" alt="user icon" style={{marginTop: "-10px", marginLeft:"-30px", border:"solid 3px #000", borderRadius:"100px", backgroundColor:"#fff", width:"50px", position:"absolute" }} />
                </div>
          
             </div>


             <div className="uk-panel uk-width-1-1 uk-visible@s">            
                                    
                <div className="uk-position-absolute uk-scrollspy-inview person-one-right uk-animation-slide-bottom-medium">
                    <img src={PersonSevenLeft} alt="person one left" className='uk-border-circle people-border'/>
                </div>
                              
                <div className="uk-position-absolute uk-scrollspy-inview person-two-right uk-animation-slide-top-medium">
                    <img src={PersonEightLeft} alt="person one left" className='uk-border-circle people-border'/>
                </div>
                              
                <div className="uk-position-absolute uk-scrollspy-inview person-three-right uk-animation-slide-bottom-medium uk-visible@m">
                    <img src={PersonNineLeft} alt="person one left" className='uk-border-circle people-border'/>
                </div>
                              
                <div className="uk-position-absolute uk-scrollspy-inview person-four-right uk-animation-slide-top-medium">
                    <img src={PersonTenLeft} alt="person one left" className='uk-border-circle people-border'/>
                </div>
                    
                <div className="uk-position-absolute uk-scrollspy-inview person-five-right uk-animation-slide-bottom-medium" >
                    <img src={pencilIcon} alt="Pencil Icon" className='uk-border-circle people-border'  style={{border:"solid 3px #000", borderRadius:"100px", backgroundColor:"#fff"}}/>
                </div>


          </div>   

          </div>                 






        </div>
    </div>
  )
}

export default FloatingPeople